import { pick } from 'lodash/fp';

export default <T = any>(shortProps: string[], completeObject: any): T =>
  pick(shortProps)(completeObject) as T;
